import pipe from 'ramda/src/pipe'
import allPass from 'ramda/src/allPass'
import length from 'ramda/src/length'
import equals from 'ramda/src/equals'
import not from 'ramda/src/not'
import isMobileResSelector from 'root/src/client/logic/app/selectors/isMobileResSelector'
import isBrandUserSelector from 'root/src/client/logic/static/selectors/isBrandUserSelector'
import isAgencyUserSelector from 'root/src/client/logic/static/selectors/isAgencyUserSelector'
import isAuthenticatedSelector from 'root/src/client/logic/auth/selectors/isAuthenticated'
import { appStoreLenses } from 'root/src/client/logic/app/lenses'
// TODO HERE IS ONE OF 2 PLACES WHERE FRONT END DEPENDS ON COGNITO.ADMINGETUSER

const { viewTokens } = appStoreLenses

export default allPass([
	pipe(isMobileResSelector, not),
	isAuthenticatedSelector,
	pipe(isBrandUserSelector, not),
	pipe(isAgencyUserSelector, not),
	viewTokens,
	pipe(
		viewTokens,
		length,
		equals(0),
	),
])
